// Quem pode escrever no módulo de grupos. O servidor só aceita criar, adotar,
// sincronizar, disparar avulso, mexer em sequência e em entrada automática
// (webhooks) de administrador da conta (check_admin_authorization?). A tela
// usa a mesma regra para não oferecer ação que volta com erro.
// Sem store (spec, tela fora do app) vale o caminho seguro: sem escrita.
export const isAccountAdministrator = store =>
  store?.getters?.getCurrentRole === 'administrator';

export default isAccountAdministrator;
